export default "__VITE_ASSET__C14IwGRL__"